


import React, { useState, useEffect } from "react";
import {
    Box, Card, CardContent, Typography, Grid, TextField,
    MenuItem, Button, Chip, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Checkbox,
    Select, InputAdornment, InputLabel, FormControl, Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
// import { FOOD_API } from "../../../config/api";
const GoalDetails = ({ formData, goals, subGoals, onInputChange, onNext, handleGoalConfigChange, setMenuItems, menuItems, groupedItems, setGroupedItems, selectedFeature }) => {
    const [expandedSubCategories, setExpandedSubCategories] = useState({});
    const [discountTarget, setDiscountTarget] = useState("overall");
    const [overallDiscount, setOverallDiscount] = useState({ type: "percentage", value: "" });
    const [categoryFilter, setCategoryFilter] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");
    const [categoryDiscounts, setCategoryDiscounts] = useState({});
    const [subCategoryDiscounts, setSubCategoryDiscounts] = useState({});
    // ✅ Replace static useState with empty array
    // const [menuItems, setMenuItems] = useState([]);
    // ✅ State additions needed at top
    const [expandedCategories, setExpandedCategories] = useState({});
    const [subCategoryBogo, setSubCategoryBogo] = useState({});
    const handleSubCategoryBogoChange = (
        categoryName,
        subCategoryName,
        field,
        value
    ) => {

        const key = `${categoryName}-${subCategoryName}`;

        const updated = {
            ...(subCategoryBogo[key] || {}),
            [field]: value
        };

        setSubCategoryBogo(prev => ({
            ...prev,
            [key]: updated
        }));

        setMenuItems(prev =>
            prev.map(item =>
                item.category === categoryName &&
                    item.subCategory === subCategoryName
                    ? {
                        ...item,
                        [field]: value
                    }
                    : item
            )
        );
    };
    const handleCategoryDiscountChange = (
        categoryName,
        value
    ) => {

        const percentage =
            Math.min(
                100,
                Math.max(
                    0,
                    Number(value || 0)
                )
            );

        setCategoryDiscounts(prev => ({
            ...prev,
            [categoryName]: percentage
        }));

        setMenuItems(prev =>
            prev.map(item =>
                item.category === categoryName &&
                    item.selected
                    ? {
                        ...item,
                        discountType: "percentage",
                        discountValue: percentage
                    }
                    : item
            )
        );
    };
    const handleSubCategoryDiscountChange = (
        categoryName,
        subCategoryName,
        value
    ) => {

        const percentage = Math.min(
            100,
            Math.max(0, Number(value || 0))
        );

        const key = `${categoryName}-${subCategoryName}`;

        setSubCategoryDiscounts(prev => ({
            ...prev,
            [key]: percentage
        }));

        setMenuItems(prev =>
            prev.map(item =>
                item.category === categoryName &&
                    item.subCategory === subCategoryName
                    ? {
                        ...item,
                        discountType: "percentage",
                        discountValue: percentage
                    }
                    : item
            )
        );

    };
    const toggleCategory = (categoryName) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryName]: !prev[categoryName]
        }));
    };
    const toggleSubCategory = (categoryName, subCategoryName) => {
        const key = `${categoryName}-${subCategoryName}`;

        setExpandedSubCategories(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    // ✅ Group menuItems by category

    // ✅ Add this useEffect to fetch and format real menu data



    const categories = ["All", ...new Set(menuItems.map(i => i.category))];
    const selectedItems = menuItems.filter(i => i.selected);

    const filteredItems = menuItems.filter(item => {
        const matchCategory = categoryFilter === "All" || item.category === categoryFilter;
        const matchSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
        return matchCategory && matchSearch;
    });


    useEffect(() => {

        const selectedItems = menuItems
            .filter(item => item.selected)
            .map(item => ({
                id: item.id,
                name: item.name,
                category: item.category,
                subCategory: item.subCategory,
                price: item.price,
                buyQty: Number(item.buyQty || 0),
                getQty: Number(item.getQty || 0),
                discountType: item.discountType,
                discountValue: item.discountValue
            }));


        if (formData.goal === "BOGO_DISCOUNT") {

            onInputChange("goalConfig", {
                ...formData.goalConfig,

                bogo: {
                    ...(formData.goalConfig?.bogo || {}),
                    selectedItems
                }

            });

        }

        if (formData.goal === "discount") {

            onInputChange("goalConfig", {
                ...formData.goalConfig,

                discount: {
                    ...(formData.goalConfig?.discount || {}),
                    selectedItems
                }

            });

        }

    }, [menuItems]);

    useEffect(() => {

        const grouped = {};

        filteredItems.forEach(item => {

            if (!grouped[item.category]) {
                grouped[item.category] = {};
            }

            if (!grouped[item.category][item.subCategory]) {
                grouped[item.category][item.subCategory] = [];
            }

            grouped[item.category][item.subCategory].push(item);

        });

        setGroupedItems(grouped);

    }, [filteredItems]);


    const toggleSelectItem = (id) => {
        setMenuItems(prev => prev.map(item => item.id === id ? { ...item, selected: !item.selected } : item));
    };

    const toggleSelectAll = () => {
        const allSelected = filteredItems.every(i => i.selected);
        const ids = filteredItems.map(i => i.id);
        setMenuItems(prev => prev.map(item => ids.includes(item.id) ? { ...item, selected: !allSelected } : item));
    };

    const updateItemDiscount = (id, field, value) => {
        setMenuItems(prev => prev.map(item => item.id === id ? { ...item, [field]: value } : item));
    };

    const discountedPrice = (item) => {
        if (!item.discountValue) return item.price;
        if (item.discountType === "percentage")
            return (item.price - (item.price * item.discountValue) / 100).toFixed(2);
        return Math.max(0, item.price - parseFloat(item.discountValue)).toFixed(2);
    };

    const getOverallFinalPrice = (price) => {
        if (!overallDiscount.value) return price;
        if (overallDiscount.type === "percentage")
            return (price - (price * overallDiscount.value) / 100).toFixed(2);
        return Math.max(0, price - parseFloat(overallDiscount.value)).toFixed(2);
    };

    return (
        <Box sx={{ mx: "auto", px: { xs: 2, md: 3 }, py: 1, marginLeft: "-20px", marginTop: "-5px" }}>
            <Card elevation={3} sx={{ borderRadius: "16px", overflow: "hidden", }}>
                <CardContent sx={{ p: { xs: 3, md: 4, } }}>

                    {/* Header */}

                    {/* Form Grid */}
                    <Grid container spacing={2} >
                        {/* Campaign Name */}


                        {/* Goal */}
                        {/* <Grid item xs={12} md={3} sx={{
                            "@media (min-width:1200px) and (max-width:1300px)": {
                                flexBasis: "33.33%",   // increase width
                                maxWidth: "33.33%",
                            }
                        }}>
                            <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151", width: "70%" }}>
                                Goal <span style={{ color: "#ef4444" }}>*</span>
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                value={formData.goal}
                                onChange={(e) => {
                                    onInputChange("goal", e.target.value);
                                    onInputChange("subGoal", "");
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        backgroundColor: "#f8fafc",
                                        fontSize: "13px",
                                        "&:hover fieldset": { borderColor: "#3b82f6" },
                                        "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                    },
                                    "& .MuiSelect-select": { fontSize: "13px" }
                                }}
                            >
                                <MenuItem value="" disabled sx={{ fontSize: "13px", color: "#9ca3af" }}>
                                    Select goal
                                </MenuItem>
                                {goals.map((goal) => (
                                    <MenuItem key={goal.value} value={goal.value} sx={{ fontSize: "13px" }}>
                                        {goal.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid> */}

                        {formData.goal !== "discount" && formData.goal !== "BOGO_DISCOUNT" && formData.goal !== "Combos" && (
                            <Grid item xs={12} md={3} sx={{
                                "@media (min-width:1200px) and (max-width:1300px)": {
                                    flexBasis: "33.33%",   // increase width
                                    maxWidth: "33.33%",
                                }
                            }}>
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Campaign Name <span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                <TextField
                                    fullWidth
                                    placeholder="Enter campaign name"
                                    value={formData.campaignName || ""}
                                    onChange={(e) => onInputChange("campaignName", e.target.value)}
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            backgroundColor: "#f8fafc",
                                            fontSize: "13px",
                                            "&:hover fieldset": { borderColor: "#3b82f6" },
                                            "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                        },
                                        "& input::placeholder": {
                                            fontSize: "13px",
                                            color: "#9ca3af"
                                        }
                                    }}
                                />
                            </Grid>
                        )}

                        {formData.goal !== "discount" && formData.goal !== "BOGO_DISCOUNT" && formData.goal !== "Combos" && (
                            <Grid item xs={12} md={formData.goal === "leads" ? 12 : 3} >
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Sub Goal <span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                {formData.goal === "leads" ? (

                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: {
                                                xs: "1fr",            // 📱 mobile → 1 card
                                                sm: "1fr",            // small → 1 card
                                                md: "repeat(2, 1fr)", // tablet → 2 cards (optional)
                                                lg: "repeat(3, 1fr)", // 💻 large → 3 cards
                                            },
                                            gap: "10px"
                                        }}
                                    >
                                        {subGoals.leads.map((sg) => {
                                            const isSelected = formData.subGoal === sg.value;
                                            return (
                                                <Box
                                                    key={sg.value}
                                                    onClick={() => onInputChange("subGoal", sg.value)}
                                                    sx={{
                                                        cursor: "pointer",
                                                        border: isSelected ? "2px solid #3b82f6" : "1.5px solid #e5e7eb",
                                                        borderRadius: "12px",
                                                        padding: "14px 12px",
                                                        backgroundColor: isSelected ? "#eff6ff" : "#f8fafc",
                                                        transition: "border-color 0.15s, background-color 0.15s",
                                                        "&:hover": {
                                                            borderColor: "#3b82f6",
                                                            backgroundColor: "#eff6ff",
                                                        },
                                                    }}
                                                >
                                                    <Box sx={{ mb: 1 }}>{sg.icon}</Box>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#111827", mb: 0.5 }}>
                                                        {sg.label}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: "11px", color: "#6b7280", lineHeight: 1.4 }}>
                                                        {sg.description}
                                                    </Typography>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                ) : (

                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        value={formData.subGoal}
                                        disabled={!formData.goal}
                                        onChange={(e) => onInputChange("subGoal", e.target.value)}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                backgroundColor: formData.goal ? "#f8fafc" : "#f1f5f9",
                                                fontSize: "13px",
                                                "&:hover fieldset": { borderColor: formData.goal ? "#3b82f6" : "#e5e7eb" },
                                                "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
                                            },
                                            "& .MuiSelect-select": { fontSize: "13px" },
                                        }}
                                    >
                                        <MenuItem value="" disabled sx={{ fontSize: "13px", color: "#9ca3af" }}>
                                            {formData.goal ? "Select sub goal" : "Select goal first"}
                                        </MenuItem>
                                        {formData.goal && subGoals[formData.goal]?.map((subGoal) => (
                                            <MenuItem key={subGoal.value} value={subGoal.value} sx={{ fontSize: "13px" }}>
                                                {subGoal.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            </Grid>
                        )}


                        {/* {formData.goal === "discount" && formData.goal !== "BOGO_DISCOUNT" && (
                            <Grid item xs={12} md={3} sx={{
                                "@media (min-width:1200px) and (max-width:1300px)": {
                                    flexBasis: "33.33%",
                                    maxWidth: "33.33%",
                                }
                            }}>
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Sub Goal<span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    value={formData.subGoal}
                                    onChange={(e) => onInputChange("subGoal", e.target.value)}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            backgroundColor: "#f8fafc",


                                            display: "flex",
                                            alignItems: "center",

                                            transition: "all 0.2s ease",

                                            "& fieldset": {
                                                borderColor: "#e5e7eb",
                                            },

                                            "&:hover fieldset": {
                                                borderColor: "#3b82f6",
                                            },

                                            "&.Mui-focused fieldset": {
                                                borderColor: "#3b82f6",
                                                borderWidth: "2px",
                                            },
                                        },

                                        "& .MuiSelect-select": {
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "6px 4px !important",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                        },
                                    }}
                                >
                                    <MenuItem value="" disabled>Select type</MenuItem>
                                    <MenuItem value="menu">Menu</MenuItem>
                                    <MenuItem value="coupons">Coupons</MenuItem>
                                    <MenuItem value="buyOneGetOne">
                                        Buy 1 Get 1
                                    </MenuItem>
                                </TextField>
                            </Grid>
                        )} */}

                    </Grid>

                    {/* ✅ DISCOUNT SECTION */}
                    {formData.goal === "discount" && formData.subGoal === "menu" && (
                        <Box sx={{ mt: 4 }}>
                            <Divider sx={{ mb: 3 }} />

                            {/* ✅ ALL CONTROLS IN ONE ROW */}
                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", mb: 3 }}>


                                {["overall", "specific"].map((type) => (
                                    <Chip
                                        key={type}
                                        label={type === "overall" ? "🍽️ Overall Menu" : "🎯 Specific Items"}
                                        onClick={() => {

                                            setDiscountTarget(type);

                                            if (type === "overall") {

                                                // Select all items
                                                setMenuItems(prev =>
                                                    prev.map(item => ({
                                                        ...item,
                                                        selected: true
                                                    }))
                                                );

                                                // Expand all categories
                                                const expanded = {};

                                                Object.keys(groupedItems).forEach(category => {
                                                    expanded[category] = true;
                                                });

                                                setExpandedCategories(expanded);

                                            } else {

                                                setMenuItems(prev =>
                                                    prev.map(item => ({
                                                        ...item,
                                                        selected: false
                                                    }))
                                                );
                                            }

                                            onInputChange("goalConfig", {
                                                ...(formData.goalConfig || {}),
                                                discount: {
                                                    ...(formData.goalConfig?.discount || {}),
                                                    discountType: type
                                                }
                                            });
                                        }}
                                        variant={discountTarget === type ? "filled" : "outlined"}
                                        color={discountTarget === type ? "primary" : "default"}
                                        sx={{ fontWeight: 600, fontSize: "13px", px: 1, cursor: "pointer", height: 36 }}
                                    />
                                ))}

                                {/* Divider line between toggle and controls */}
                                <Divider orientation="vertical" flexItem />





                                {discountTarget === "overall" &&
                                    formData?.goalConfig?.discount?.discountType !== "bogo" && (
                                        <TextField
                                            size="small"
                                            type="number"
                                            placeholder={
                                                formData?.goalConfig?.discount?.discountType === "percentage"
                                                    ? "Enter %"
                                                    : "Enter %"
                                            }
                                            value={formData?.goalConfig?.discount?.discountValue || ""}
                                            onChange={(e) =>
                                                handleGoalConfigChange(
                                                    "discount",
                                                    "discountValue",
                                                    Math.max(0, e.target.value)
                                                )
                                            }
                                            sx={{
                                                width: 150,
                                                height: 35,
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "10px",
                                                    backgroundColor: "#fff7ed",
                                                    fontWeight: 600,
                                                    "&:hover fieldset": { borderColor: "#f97316" },
                                                    "&.Mui-focused fieldset": { borderColor: "#ea580c" }
                                                },
                                                "& input": {
                                                    fontWeight: 700,
                                                    fontSize: "15px",
                                                    color: "#c2410c"
                                                }
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: "14px",
                                                                color: "#ea580c",
                                                                backgroundColor: "#ffedd5",
                                                                px: 1,
                                                                py: 0.3,
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            {formData?.goalConfig?.discount?.discountType === "percentage"
                                                                ? "%"
                                                                : "%"}
                                                        </Typography>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}



                                {discountTarget === "specific" && (
                                    <TextField
                                        size="small"
                                        placeholder="Search items..."
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                        sx={{ width: 200, }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                )}

                                {/* Category filter chips — only for specific */}
                                {discountTarget === "specific" && (
                                    <FormControl size="small" sx={{
                                        minWidth: 160,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            backgroundColor: "#f8fafc",
                                            "&:hover fieldset": { borderColor: "#3b82f6" },
                                            "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                        }
                                    }}>
                                        <Select
                                            value={categoryFilter}
                                            displayEmpty
                                            onChange={e => setCategoryFilter(e.target.value)}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <span>🗂️</span>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                                        {selected === "All" ? "All Categories" : selected}
                                                    </Typography>
                                                </Box>
                                            )}
                                        >
                                            {categories.map(cat => (
                                                <MenuItem key={cat} value={cat} sx={{ fontSize: "13px" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                        <Typography sx={{ fontSize: "13px" }}>
                                                            {cat === "All" ? "🗂️ All Categories" : cat}
                                                        </Typography>
                                                        {categoryFilter === cat && (
                                                            <Chip label="✓" size="small" color="primary" sx={{ height: "18px", fontSize: "11px" }} />
                                                        )}
                                                    </Box>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {/* Live summary chip — overall only */}
                                {discountTarget === "overall" && (overallDiscount.value || overallDiscount.type === "bogo") && (
                                    <Chip
                                        label={
                                            overallDiscount.type === "bogo"
                                                ? "Buy 1 Get 1 Free on all items"
                                                : overallDiscount.type === "percentage"
                                                    ? `${overallDiscount.value}% off on all items`
                                                    : `₹${overallDiscount.value} off on all items`
                                        }
                                        color="success"
                                        size="small"
                                        sx={{ fontWeight: 600, height: 36 }}
                                    />
                                )}

                            </Box>

                            {/* Overall Preview Table */}
                            {discountTarget === "overall" && (
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "10px" }}>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: "#f97316" }}>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox checked />
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff", width: 40 }} />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Item / Category</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Original Price</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Discounted Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.entries(groupedItems).map(([categoryName, subCategories]) => (
                                                <React.Fragment key={categoryName}>

                                                    {/* Category */}
                                                    <TableRow
                                                        sx={{
                                                            background: "#fff7ed",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => toggleCategory(categoryName)}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <IconButton size="small">
                                                                {expandedCategories[categoryName]
                                                                    ? <KeyboardArrowUp />
                                                                    : <KeyboardArrowDown />}
                                                            </IconButton>
                                                        </TableCell>

                                                        <TableCell colSpan={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    color: "#c2410c"
                                                                }}
                                                            >
                                                                🍽️ {categoryName}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>

                                                    {expandedCategories[categoryName] &&
                                                        Object.entries(subCategories).map(([subCategoryName, items]) => {

                                                            const subKey = `${categoryName}-${subCategoryName}`;

                                                            return (
                                                                <React.Fragment key={subKey}>

                                                                    {/* Sub Category */}
                                                                    <TableRow
                                                                        sx={{
                                                                            background: "#fffaf3",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() =>
                                                                            toggleSubCategory(
                                                                                categoryName,
                                                                                subCategoryName
                                                                            )
                                                                        }
                                                                    >
                                                                        <TableCell padding="checkbox">
                                                                            <IconButton size="small">
                                                                                {expandedSubCategories[subKey]
                                                                                    ? <KeyboardArrowUp fontSize="small" />
                                                                                    : <KeyboardArrowDown fontSize="small" />}
                                                                            </IconButton>
                                                                        </TableCell>

                                                                        <TableCell colSpan={4}>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontWeight: 600,
                                                                                    color: "#ea580c",
                                                                                    pl: 2
                                                                                }}
                                                                            >
                                                                                📂 {subCategoryName}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    {/* Items */}
                                                                    {expandedSubCategories[subKey] &&
                                                                        items.map(item => (
                                                                            <TableRow key={item.id}>

                                                                                <TableCell padding="checkbox">
                                                                                    <Checkbox
                                                                                        checked={item.selected}
                                                                                        onChange={() =>
                                                                                            toggleSelectItem(item.id)
                                                                                        }
                                                                                    />
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    <Typography sx={{ pl: 4 }}>
                                                                                        {item.name}
                                                                                    </Typography>
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    ₹{item.price}
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    <TextField
                                                                                        size="small"
                                                                                        type="number"
                                                                                        disabled={!item.selected}
                                                                                        value={item.buyQty || ""}
                                                                                        onChange={e =>
                                                                                            updateItemDiscount(
                                                                                                item.id,
                                                                                                "buyQty",
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        sx={{ width: 80 }}
                                                                                    />
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    <TextField
                                                                                        size="small"
                                                                                        type="number"
                                                                                        disabled={!item.selected}
                                                                                        value={item.getQty || ""}
                                                                                        onChange={e =>
                                                                                            updateItemDiscount(
                                                                                                item.id,
                                                                                                "getQty",
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        sx={{ width: 80 }}
                                                                                    />
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        ))}

                                                                </React.Fragment>
                                                            );
                                                        })}
                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                            {/* Specific Items Table */}
                            {discountTarget === "specific" && (
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "10px" }}>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: "#f97316" }}>
                                            <TableRow>
                                                <TableCell padding="checkbox" />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff", width: 40 }} />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Item</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Price</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Discount Type</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Value</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Final Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.entries(groupedItems)
                                                .filter(([categoryName]) =>
                                                    categoryFilter === "All" || categoryFilter === categoryName
                                                )
                                                .map(([categoryName, subCategories]) => (

                                                    <React.Fragment key={categoryName}>

                                                        {/* Category Row */}
                                                        <TableRow
                                                            sx={{
                                                                backgroundColor: "#fff7ed",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <TableCell />
                                                            <TableCell onClick={() => toggleCategory(categoryName)}>
                                                                <IconButton size="small">
                                                                    {expandedCategories[categoryName] ? (
                                                                        <KeyboardArrowUp fontSize="small" />
                                                                    ) : (
                                                                        <KeyboardArrowDown fontSize="small" />
                                                                    )}
                                                                </IconButton>
                                                            </TableCell>

                                                            <TableCell colSpan={5}>
                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: "#c2410c"
                                                                    }}
                                                                >
                                                                    🍽️ {categoryName}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>

                                                        {expandedCategories[categoryName] &&
                                                            Object.entries(subCategories).map(([subCategoryName, items]) => {

                                                                const visibleItems = items.filter(item =>
                                                                    item.name
                                                                        .toLowerCase()
                                                                        .includes(searchTerm.toLowerCase())
                                                                );

                                                                if (visibleItems.length === 0) return null;

                                                                const allSelected =
                                                                    visibleItems.every(i => i.selected);

                                                                const someSelected =
                                                                    visibleItems.some(i => i.selected);

                                                                return (

                                                                    <React.Fragment
                                                                        key={`${categoryName}-${subCategoryName}`}
                                                                    >

                                                                        {/* Sub Category */}
                                                                        <TableRow
                                                                            sx={{
                                                                                background: "#fffaf3"
                                                                            }}
                                                                        >
                                                                            <TableCell
                                                                                padding="checkbox"
                                                                            >
                                                                                <Checkbox
                                                                                    checked={allSelected}
                                                                                    indeterminate={
                                                                                        someSelected &&
                                                                                        !allSelected
                                                                                    }
                                                                                    onChange={() => {

                                                                                        const shouldSelect =
                                                                                            !allSelected;

                                                                                        setMenuItems(prev =>
                                                                                            prev.map(menu =>
                                                                                                visibleItems.some(
                                                                                                    x => x.id === menu.id
                                                                                                )
                                                                                                    ? {
                                                                                                        ...menu,
                                                                                                        selected:
                                                                                                            shouldSelect
                                                                                                    }
                                                                                                    : menu
                                                                                            )
                                                                                        );

                                                                                    }}
                                                                                />
                                                                            </TableCell>

                                                                            <TableCell />

                                                                            <TableCell colSpan={5}>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center"
                                                                                    }}
                                                                                >
                                                                                    <Typography
                                                                                        sx={{
                                                                                            pl: 2,
                                                                                            fontWeight: 600,
                                                                                            color: "#ea580c"
                                                                                        }}
                                                                                    >
                                                                                        📂 {subCategoryName}
                                                                                    </Typography>

                                                                                    <Box
                                                                                        sx={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            gap: 1
                                                                                        }}
                                                                                    >


                                                                                        <TextField
                                                                                            size="small"
                                                                                            type="number"
                                                                                            placeholder="%"
                                                                                            value={
                                                                                                subCategoryDiscounts[
                                                                                                `${categoryName}-${subCategoryName}`
                                                                                                ] || ""
                                                                                            }
                                                                                            onChange={(e) =>
                                                                                                handleSubCategoryDiscountChange(
                                                                                                    categoryName,
                                                                                                    subCategoryName,
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                            sx={{
                                                                                                width: 90
                                                                                            }}
                                                                                            InputProps={{
                                                                                                endAdornment: (
                                                                                                    <InputAdornment position="end">
                                                                                                        %
                                                                                                    </InputAdornment>
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                    </Box>
                                                                                </Box>
                                                                            </TableCell>
                                                                        </TableRow>

                                                                        {/* Items */}
                                                                        {visibleItems.map(item => (

                                                                            <TableRow key={item.id}>

                                                                                <TableCell
                                                                                    padding="checkbox"
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={item.selected}
                                                                                        onChange={() =>
                                                                                            toggleSelectItem(item.id)
                                                                                        }
                                                                                    />
                                                                                </TableCell>

                                                                                <TableCell />

                                                                                <TableCell>
                                                                                    {item.name}
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    ₹{item.price}
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    <Select
                                                                                        size="small"
                                                                                        value={item.discountType}
                                                                                        disabled={!item.selected}
                                                                                        onChange={e =>
                                                                                            updateItemDiscount(
                                                                                                item.id,
                                                                                                "discountType",
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <MenuItem value="percentage">
                                                                                            % Off
                                                                                        </MenuItem>
                                                                                    </Select>
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    <TextField
                                                                                        size="small"
                                                                                        type="number"
                                                                                        value={item.discountValue}
                                                                                        disabled={!item.selected}
                                                                                        onChange={e =>
                                                                                            updateItemDiscount(
                                                                                                item.id,
                                                                                                "discountValue",
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        sx={{ width: 80 }}
                                                                                    />
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    {item.selected
                                                                                        ? `₹${discountedPrice(item)}`
                                                                                        : `₹${item.price}`}
                                                                                </TableCell>

                                                                            </TableRow>

                                                                        ))}

                                                                    </React.Fragment>

                                                                );

                                                            })}

                                                    </React.Fragment>

                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Box>
                    )}

                    {formData.goal === "BOGO_DISCOUNT" && (

                        <Box >

                            <Divider sx={{ mb: 3 }} />



                            <TableContainer
                                component={Paper}
                                variant="outlined"
                                sx={{ borderRadius: "12px" }}
                            >

                                <Table size="small">

                                    <TableHead
                                        sx={{
                                            backgroundColor: "#f97316"
                                        }}
                                    >
                                        <TableRow>

                                            <TableCell
                                                padding="checkbox"
                                                sx={{ color: "#fff" }}
                                            />

                                            <TableCell
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Item / Category
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Price
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Buy Qty
                                            </TableCell>

                                            <TableCell
                                                sx={{
                                                    color: "#fff",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Get Qty
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {Object.entries(groupedItems).map(([categoryName, subCategories]) => (
                                            <React.Fragment key={categoryName}>

                                                {/* Category */}
                                                <TableRow sx={{ background: "#fff7ed" }}>
                                                    <TableCell
                                                        padding="checkbox"
                                                        sx={{
                                                            width: 60,
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => toggleCategory(categoryName)}
                                                        >
                                                            {expandedCategories?.[categoryName]
                                                                ? <ExpandMoreIcon />
                                                                : <ChevronRightIcon />}
                                                        </IconButton>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: "#c2410c"
                                                            }}
                                                        >
                                                            🍽️ {categoryName}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell />
                                                    <TableCell />
                                                    <TableCell />
                                                </TableRow>

                                                {expandedCategories?.[categoryName] &&
                                                    Object.entries(subCategories).map(
                                                        ([subCategoryName, items]) => {

                                                            const allSelected = items.every(i => i.selected);

                                                            const someSelected =
                                                                items.some(i => i.selected);

                                                            return (
                                                                <React.Fragment
                                                                    key={`${categoryName}-${subCategoryName}`}
                                                                >

                                                                    {/* Sub Category */}
                                                                    <TableRow
                                                                        sx={{
                                                                            background: "#fffaf3"
                                                                        }}
                                                                    >
                                                                        <TableCell padding="checkbox">
                                                                            <Checkbox
                                                                                checked={allSelected}
                                                                                indeterminate={
                                                                                    someSelected &&
                                                                                    !allSelected
                                                                                }
                                                                                onChange={() => {

                                                                                    const shouldSelect =
                                                                                        !allSelected;

                                                                                    setMenuItems(prev =>
                                                                                        prev.map(menu =>
                                                                                            menu.category === categoryName &&
                                                                                                menu.subCategory === subCategoryName
                                                                                                ? {
                                                                                                    ...menu,
                                                                                                    selected: shouldSelect
                                                                                                }
                                                                                                : menu
                                                                                        )
                                                                                    );

                                                                                }}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell>
                                                                            <Typography
                                                                                sx={{
                                                                                    fontWeight: 600,
                                                                                    color: "#ea580c",
                                                                                    pl: 1
                                                                                }}
                                                                            >
                                                                                📂 {subCategoryName}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        <TableCell />

                                                                        {/* Buy Qty */}
                                                                        <TableCell>
                                                                            <TextField
                                                                                size="small"
                                                                                type="number"
                                                                                placeholder="Buy"
                                                                                value={
                                                                                    subCategoryBogo[
                                                                                        `${categoryName}-${subCategoryName}`
                                                                                    ]?.buyQty || ""
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleSubCategoryBogoChange(
                                                                                        categoryName,
                                                                                        subCategoryName,
                                                                                        "buyQty",
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                                sx={{ width: 90 }}
                                                                            />
                                                                        </TableCell>

                                                                        {/* Get Qty */}
                                                                        <TableCell>
                                                                            <TextField
                                                                                size="small"
                                                                                type="number"
                                                                                placeholder="Get"
                                                                                value={
                                                                                    subCategoryBogo[
                                                                                        `${categoryName}-${subCategoryName}`
                                                                                    ]?.getQty || ""
                                                                                }
                                                                                onChange={(e) =>
                                                                                    handleSubCategoryBogoChange(
                                                                                        categoryName,
                                                                                        subCategoryName,
                                                                                        "getQty",
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                                sx={{ width: 90 }}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    {/* Items */}
                                                                    {items.map(item => (
                                                                        <TableRow key={item.id}>

                                                                            <TableCell padding="checkbox">
                                                                                <Checkbox
                                                                                    checked={item.selected}
                                                                                    onChange={() =>
                                                                                        toggleSelectItem(item.id)
                                                                                    }
                                                                                />
                                                                            </TableCell>

                                                                            <TableCell sx={{ pl: 4 }}>
                                                                                {item.name}
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                ₹{item.price}
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                <TextField
                                                                                    size="small"
                                                                                    type="number"
                                                                                    placeholder="Buy"
                                                                                    disabled={!item.selected}
                                                                                    value={item.buyQty || ""}
                                                                                    onChange={(e) =>
                                                                                        updateItemDiscount(
                                                                                            item.id,
                                                                                            "buyQty",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    sx={{ width: 90 }}
                                                                                />
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                <TextField
                                                                                    size="small"
                                                                                    type="number"
                                                                                    placeholder="Get"
                                                                                    disabled={!item.selected}
                                                                                    value={item.getQty || ""}
                                                                                    onChange={(e) =>
                                                                                        updateItemDiscount(
                                                                                            item.id,
                                                                                            "getQty",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    sx={{ width: 90 }}
                                                                                />
                                                                            </TableCell>

                                                                        </TableRow>
                                                                    ))}

                                                                </React.Fragment>
                                                            );
                                                        }
                                                    )}

                                            </React.Fragment>
                                        ))}
                                    </TableBody>
                                </Table>

                            </TableContainer>

                        </Box>

                    )}


                    {formData.goal === "Combos" && formData.subGoal === "offers" && (
                        <Box sx={{ mt: 4 }}>
                            <Divider sx={{ mb: 3 }} />

                            <Typography
                                sx={{
                                    fontSize: "18px",
                                    fontWeight: 700,
                                    color: "#333",
                                    mb: 3
                                }}
                            >
                                Combo Offer Details
                            </Typography>

                            <Grid container spacing={2}>

                                {/* Combo Name */}
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                                        Combo Name
                                        <span style={{ color: "red" }}> *</span>
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Ex : Family Combo"
                                        value={formData.comboName || ""}
                                        onChange={(e) =>
                                            onInputChange("comboName", e.target.value)
                                        }
                                    />
                                </Grid>

                                {/* Combo Price */}
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                                        Combo Price
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        placeholder="₹ 299"
                                        value={formData.comboPrice || ""}
                                        onChange={(e) =>
                                            onInputChange("comboPrice", e.target.value)
                                        }
                                    />
                                </Grid>

                                {/* Menu Items */}
                                <Grid item xs={12}>
                                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                                        Select Combo Items
                                        <span style={{ color: "red" }}> *</span>
                                    </Typography>

                                    <FormControl fullWidth size="small">

                                        <Select
                                            multiple
                                            value={formData.comboItems || []}
                                            onChange={(e) =>
                                                onInputChange("comboItems", e.target.value)
                                            }
                                            renderValue={(selected) =>
                                                selected
                                                    .map(id => {
                                                        const item = menuItems.find(x => x.id === id);
                                                        return item?.name;
                                                    })
                                                    .join(", ")
                                            }
                                        >
                                            {menuItems.map(item => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    <Checkbox
                                                        checked={(formData.comboItems || []).includes(item.id)}
                                                    />
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </FormControl>
                                </Grid>

                                {/* Description */}
                                <Grid item xs={12}>
                                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                                        Combo Description
                                    </Typography>

                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        placeholder="Write short description..."
                                        value={formData.comboDescription || ""}
                                        onChange={(e) =>
                                            onInputChange("comboDescription", e.target.value)
                                        }
                                    />
                                </Grid>

                            </Grid>
                        </Box>
                    )}


                    {/* Footer */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<ArrowForwardIcon />}
                            onClick={onNext}
                            disabled={
                                !formData.goal ||
                                (
                                    formData.goal !== "discount" &&
                                    formData.goal !== "BOGO_DISCOUNT" &&
                                    !formData.subGoal
                                )
                            }
                            sx={{ borderRadius: "10px", px: 4, fontWeight: 600, textTransform: "none" }}
                        >
                            Next
                        </Button>
                    </Box>

                </CardContent>
            </Card>
        </Box >
    );
};

export default GoalDetails;